<div class="base-toast-alert-block d-flex flex-column toast-container p-3">
  <base-toast-alert-item
    *ngFor="let alert of alerts$ | async"
    [alert]="alert"
  ></base-toast-alert-item>
</div>
